import axios, {AxiosError, AxiosRequestConfig} from 'axios';
import {HOST} from '../constants';
import {updateErrorAction} from '../store/actions/error';
import {store} from '../store/store';

const http = axios.create({});
http.defaults.withCredentials = true;
axios.defaults.withCredentials = true;

http.interceptors.response.use(
    (response) => response,
    (error) => {
        const loginPath = '/login';
        if (error.response?.status === 401) {
            if (window.location.pathname !== loginPath) window.location.href = loginPath;
        }
        return Promise.reject(error);
    }
);

// eslint-disable-next-line
export const httpGet = <T = any>(url: string, config: AxiosRequestConfig = {}): Promise<T> => {
    return http
        .get<T>(`${HOST}/${url}`, config)
        .then((response) => response.data)
        .catch(errorHandler);
};

// eslint-disable-next-line
export const httpGetWithHeaders = (url: string, config: AxiosRequestConfig = {}) => {
    return http
        .get(`${HOST}/${url}`, config)
        .then((response) => response)
        .catch(errorHandler);
};

// eslint-disable-next-line
export const httpPost = <T = any>(url: string, data?: any, config: AxiosRequestConfig = {}): Promise<T> => {
    return http
        .post<T>(`${HOST}/${url}`, data, config)
        .then((response) => response.data)
        .catch(errorHandler);
};

// eslint-disable-next-line
export const httpPut = <T = any>(url: string, data?: any, config: AxiosRequestConfig = {}): Promise<T> => {
    return http
        .put<T>(`${HOST}/${url}`, data, config)
        .then((response) => response.data)
        .catch(errorHandler);
};

// eslint-disable-next-line
export const httpDelete = <T = any>(url: string, data: any, config: AxiosRequestConfig = {}): Promise<T> => {
    return http
        .delete<T>(`${HOST}/${url}`, {...config, data})
        .then((response) => response.data)
        .catch(errorHandler);
};

// eslint-disable-next-line
export const httpPatch = <T = any>(url: string, data?: any, config: AxiosRequestConfig = {}): Promise<T> => {
    return http
        .patch<T>(`${HOST}/${url}`, data, config)
        .then((response) => response.data)
        .catch(errorHandler);
};

// eslint-disable-next-line
const errorHandler = (error: AxiosError): any => {
    if (error.code === 'ERR_NETWORK') {
        store.dispatch(updateErrorAction(error.message, 'errorHandling.connectionError', error));
    } else if (error.response !== undefined) {
        throw error;
    }
};
